export const RADIANT_DAY_TITLE_IDS = [
  "regent-tresor",
  "quinze-souverain",
  "queteur-emerite",
  "franc-veneur",
  "chasseur-tresors",
  "gardien-reliques",
  "apothicaire",
  "joaillier",
  "grand-lecteur",
  "seigneur-vignoble",
  "jour-radieux",
  "capitaine-vaisseau",
  "mnemosyne",
];

export const RADIANT_DAY_TITLE_PROGRESS_LEFT_IDS = [
  "queteur-emerite",
  "gardien-reliques",
  "chasseur-tresors",
  "apothicaire",
  "joaillier",
  "mnemosyne",
];

export const RADIANT_DAY_TITLE_PROGRESS_RIGHT_IDS = [
  "franc-veneur",
  "seigneur-vignoble",
  "grand-lecteur",
  "capitaine-vaisseau",
  "quinze-souverain",
  "regent-tresor",
];

export const RADIANT_DAY_BLASON_DISPLAY_TITLE_IDS = [
  "jour-radieux",
  ...RADIANT_DAY_TITLE_PROGRESS_RIGHT_IDS,
  ...RADIANT_DAY_TITLE_PROGRESS_LEFT_IDS,
];

export function orderTitlesForProgressGrid(titles = []) {
  const byId = new Map((Array.isArray(titles) ? titles : []).map((title) => [title.id, title]));
  const ordered = [];
  const used = new Set();
  const slotCount = Math.max(
    RADIANT_DAY_TITLE_PROGRESS_LEFT_IDS.length,
    RADIANT_DAY_TITLE_PROGRESS_RIGHT_IDS.length
  );

  for (let index = 0; index < slotCount; index += 1) {
    const leftId = RADIANT_DAY_TITLE_PROGRESS_LEFT_IDS[index];
    const rightId = RADIANT_DAY_TITLE_PROGRESS_RIGHT_IDS[index];
    if (leftId && byId.has(leftId)) {
      ordered.push(byId.get(leftId));
      used.add(leftId);
    }
    if (rightId && byId.has(rightId)) {
      ordered.push(byId.get(rightId));
      used.add(rightId);
    }
  }

  for (const title of titles) {
    if (title?.id && !used.has(title.id)) ordered.push(title);
  }

  return ordered;
}

export const RADIANT_DAY_BLASONS_PER_PAGE = 15;
export const RADIANT_DAY_BLASON_PAGE_COUNT = 5;
export const RADIANT_DAY_BLASON_GRID_COLUMNS = 5;

function loadBlasonEntries() {
  const context = require.context("../assets/blasons", false, /\.png$/);
  return context
    .keys()
    .map((key) => {
      const fileName = key.replace("./", "");
      const match = fileName.match(/^(\d+)\.(.+)\.png$/);
      if (!match) return null;

      const index = Number.parseInt(match[1], 10);
      return {
        index,
        gradeName: match[2],
        imageSrc: context(key),
        fileName,
      };
    })
    .filter(Boolean)
    .sort((left, right) => left.index - right.index);
}

export const RADIANT_DAY_BLASONS = loadBlasonEntries();

export function getBlasonByIndex(index) {
  const numericIndex = Number(index);
  if (!Number.isFinite(numericIndex) || numericIndex < 0) return null;
  return RADIANT_DAY_BLASONS.find((entry) => entry.index === numericIndex) || null;
}

export function getRoturierBlason() {
  return getBlasonByIndex(0);
}

function getBlasonsForTitleDisplay(titleId) {
  const titleIndex = RADIANT_DAY_TITLE_IDS.indexOf(titleId);
  if (titleIndex < 0) return [];
  const startIndex = titleIndex * 5 + 1;
  return [0, 1, 2, 3, 4]
    .map((offset) => getBlasonByIndex(startIndex + offset))
    .filter(Boolean);
}

export const RADIANT_DAY_BLASON_PAGES = Array.from(
  { length: RADIANT_DAY_BLASON_PAGE_COUNT },
  (_, pageIndex) => {
    const startTitle = pageIndex * 3;
    const titleIds = RADIANT_DAY_BLASON_DISPLAY_TITLE_IDS.slice(
      startTitle,
      startTitle + 3
    );
    return titleIds.flatMap(getBlasonsForTitleDisplay);
  }
);

export function getTitleIdForBlasonIndex(blasonIndex) {
  const numericIndex = Number(blasonIndex);
  if (!Number.isFinite(numericIndex) || numericIndex < 1) return null;
  const titleIndex = Math.floor((numericIndex - 1) / 5);
  return RADIANT_DAY_TITLE_IDS[titleIndex] || null;
}

export function getGradeLevelForBlasonIndex(blasonIndex) {
  const numericIndex = Number(blasonIndex);
  if (!Number.isFinite(numericIndex) || numericIndex < 1) return 0;
  return ((numericIndex - 1) % 5) + 1;
}

export function isBlasonUnlocked(blasonIndex, achievedGradeByTitleId) {
  const titleId = getTitleIdForBlasonIndex(blasonIndex);
  if (!titleId) return false;
  const gradeLevel = getGradeLevelForBlasonIndex(blasonIndex);
  const achieved = Number(achievedGradeByTitleId?.[titleId]) || 0;
  return achieved >= gradeLevel;
}

export function getRowTitleIdForPageRow(pageIndex, rowIndex) {
  const titleIndex = pageIndex * 3 + rowIndex;
  return RADIANT_DAY_BLASON_DISPLAY_TITLE_IDS[titleIndex] || null;
}

export function isRowEndColumn(slotIndex) {
  return slotIndex % RADIANT_DAY_BLASON_GRID_COLUMNS === RADIANT_DAY_BLASON_GRID_COLUMNS - 1;
}

export function getBlasonForTitle(titleId, achievedGrade) {
  const grade = Number(achievedGrade) || 0;
  if (grade < 1) return null;

  const titleIndex = RADIANT_DAY_TITLE_IDS.indexOf(titleId);
  if (titleIndex < 0) return null;

  return getBlasonByIndex(titleIndex * 5 + grade);
}
